import React, { useEffect, useRef, useState } from 'react';
import { getOffset } from '../utils/utilities';
const StickyBar = () => {
    const [sections, setSections] = useState([]);
    const [isFixed, setIsFixed] = useState(false);
    const [hideStickyBar, setHideStickyBar] = useState(false);
    const [atcHtml, setAtcHtml] = useState('');
    const [offsetHeight, setOffsetHeight] = useState(0);
    const [activeSection, setActiveSection] = useState(0);
    const [manualActiveSection, setManualActiveSection] = useState(-1);
    const [scrollDisabled, setScrollDisabled] = useState(false);
    const stickyBarRef = useRef(null);
    const scrollingSections = useRef([]);
    const isProductPage = document.querySelector("[class*='product']") ? true : false;
    const isVisible = (el) => {
        // check if the element is visible inside horizontal scrollable parent, sticky-bar__inner
        let stickyBarInner = document.querySelector('.sticky-bar__inner');
        let stickyBarInnerRect = stickyBarInner.getBoundingClientRect();
        let elRect = el.getBoundingClientRect();
        let elLeft = elRect.left;
        let elRight = elRect.right;
        let stickyBarInnerLeft = stickyBarInnerRect.left;
        let stickyBarInnerRight = stickyBarInnerRect.right;
        let isLeftVisible = elLeft >= stickyBarInnerLeft;
        let isRightVisible = elRight <= stickyBarInnerRight;
        return isLeftVisible && isRightVisible;
    };
    const scrollEvent = () => {
        let header = document.querySelector('.header');
        let announcementBar = document.querySelector('.notification-bar');
        let currOffset = header.offsetHeight + announcementBar.offsetHeight;
        const currentScroll = window.scrollY + currOffset;
        let stickyPos = getOffset(document.querySelector('.sticky-bar-wrapper')).top;
        if (currentScroll >= stickyPos) {
            setIsFixed(true);
        }
        else {
            setIsFixed(false);
        }
        let pastLastSection = currentScroll >= scrollingSections.current[scrollingSections.current.length - 1].el.offsetTop + scrollingSections.current[scrollingSections.current.length - 1].el.offsetHeight;
        if (pastLastSection) {
            setHideStickyBar(true);
        }
        else {
            setHideStickyBar(false);
        }
        let currSection = scrollingSections.current.findIndex((section, i) => {
            let sectionEl = document.querySelector(`*[data-sticky-target="${section.title}"]`);
            let hasNext = scrollingSections.current[i + 1];
            let sectionTop = sectionEl.offsetTop;
            let sectionBottom = sectionTop + sectionEl.offsetHeight;
            let bottomScrollThreshold = sectionBottom;
            if (hasNext) {
                let nextSectionEl = document.querySelector(`*[data-sticky-target="${scrollingSections.current[i + 1].title}"]`);
                bottomScrollThreshold = nextSectionEl.offsetTop;
            }
            let isCurrent = currentScroll >= sectionTop && currentScroll <= bottomScrollThreshold;
            return isCurrent;
        });
        if (currSection > -1) {
            let currentEl = document.querySelector(`.sticky-bar--fixed .sticky-bar__item:nth-child(${currSection + 1})`);
            if (currentEl && !isVisible(currentEl)) {
                document.querySelector(`.sticky-bar--fixed .sticky-bar__inner`).scrollTo({
                    left: currentEl.offsetLeft - 16,
                });
            }
        }
        setActiveSection(currSection);
    };
    const scrollToSection = (section) => {
        let sectionEl = document.querySelector(`*[data-sticky-target="${section.title}"]`);
        let header = document.querySelector('.header');
        let announcementBar = document.querySelector('.notification-bar');
        let currOffset = header.offsetHeight + announcementBar.offsetHeight;
        let sectionTop = sectionEl.offsetTop;
        setScrollDisabled(true);
        setManualActiveSection(sections.findIndex((s) => s.title == section.title));
        const interval = setInterval(() => {
            if (window.scrollY == sectionTop - currOffset + 10) {
                console.log('scroll enabled');
                setScrollDisabled(false);
                clearInterval(interval);
                setManualActiveSection(-1);
            }
        }, 100);
        window.scrollTo({
            top: sectionTop - currOffset + 10,
            behavior: 'smooth'
        });
    };
    const scrollDisable = (e) => {
        if (scrollDisabled) {
            e.preventDefault();
            e.stopPropagation();
            return false;
        }
    };
    const complimentaryListener = (e) => {
        const complimentaryCheckbox = document.querySelector('.product__complimentary input[type="checkbox"]');
        const stickyATCButton = document.querySelector('.sticky-bar__button add-to-cart-button');
        if (complimentaryCheckbox.checked) {
            stickyATCButton.dataset.addAdditional = 'true';
        }
        else {
            stickyATCButton.dataset.addAdditional = 'false';
        }
    };
    const htmlSetter = () => {
        const productButton = document.querySelector('.sticky-bar__atc');
        const outOfStockButton = document.querySelector('.product-oos');
        if (!outOfStockButton.classList.contains('product-oos__hidden')) {
            setAtcHtml(outOfStockButton.innerHTML);
        }
        else if (productButton) {
            setAtcHtml(productButton.innerHTML);
        }
    };
    useEffect(() => {
        const sections = document.querySelectorAll('*[data-sticky-target]');
        const sectionTabs = [];
        if (!sections || sections.length == 0)
            return;
        sections.forEach((section) => {
            sectionTabs.push({
                title: section.dataset.stickyTarget,
                el: section
            });
        });
        window.addEventListener('scroll', scrollEvent);
        window.addEventListener('mousewheel', scrollDisable, {
            capture: true,
            passive: false
        });
        window.addEventListener('DOMMouseScroll', scrollDisable, {
            capture: true,
            passive: false
        });
        setSections(sectionTabs);
        scrollingSections.current = sectionTabs;
        let header = document.querySelector('.header');
        let announcementBar = document.querySelector('.notification-bar');
        setOffsetHeight(header.offsetHeight + announcementBar.offsetHeight);
        const variantSelect = document.querySelector('[data-product-form] [name="id"]');
        variantSelect.addEventListener('change', htmlSetter);
        htmlSetter();
        const complimentaryCheckbox = document.querySelector('.product__complimentary input[type="checkbox"]');
        if (complimentaryCheckbox) {
            complimentaryCheckbox.addEventListener('change', complimentaryListener);
        }
        setTimeout(() => {
            scrollEvent();
        }, 100);
        return () => {
            window.removeEventListener('scroll', scrollEvent);
            complimentaryCheckbox.removeEventListener('change', complimentaryListener);
        };
    }, []);
    let stickyBarClass = 'sticky-bar';
    if (isFixed) {
        stickyBarClass += ' sticky-bar--fixed';
    }
    if (hideStickyBar) {
        stickyBarClass += ' sticky-bar--hidden';
    }
    if (!sections || sections.length == 0)
        return (React.createElement(React.Fragment, null));
    return (React.createElement("div", { className: "sticky-bar-wrapper" },
        React.createElement("div", { className: stickyBarClass, style: { "--offset": `${offsetHeight}px` } },
            React.createElement("div", { className: `sticky-bar__inner` },
                sections.map((section, i) => (React.createElement("div", { key: i, className: `sticky-bar__item ${(manualActiveSection !== -1 ? manualActiveSection : activeSection) == i ? 'sticky-bar__item--active' : ''}`, onClick: () => scrollToSection(section), "aria-label": 'Scroll to section' }, section.title))),
                isProductPage && (React.createElement("div", { className: 'sticky-bar__button', dangerouslySetInnerHTML: { __html: atcHtml } })))),
        isFixed && React.createElement("div", { className: "sticky-bar sticky-bar__placeholder" },
            React.createElement("div", { className: `sticky-bar__inner`, ref: stickyBarRef },
                sections.map((section, i) => (React.createElement("div", { key: i, className: `sticky-bar__item ${(manualActiveSection !== -1 ? manualActiveSection : activeSection) == i ? 'sticky-bar__item--active' : ''}`, onClick: () => scrollToSection(section), "aria-label": 'Scroll to section' }, section.title))),
                isProductPage && (React.createElement("div", { className: 'sticky-bar__button', dangerouslySetInnerHTML: { __html: atcHtml } }))))));
};
export default StickyBar;
